<template>
  <main class="mb-0">
	  <div v-if="group === 'EH'">
		  <p>I declare that the information on this Application Form is true and accurate to my full knowledge.</p>
		  <p>I agree that in the case of learning support needs, the school will carefully assess whether it can provide
			  adequate support for my child to be successful in his/her learning before confirming my child's enrolment. I
			  understand that any failure to declare such information will result in the offer of a place being withdrawn or
			  impact the continued enrolment of my child. Disclosing all required information will ensure that informed
			  decisions are made in the best interest of my child. I agree that in the event that the school identifies a
			  learning need prior to or during my child's term of enrolment, the school reserves the right to request my
			  family to provide support of a shadow teacher. I agree that if this is required, the cost of this additional
			  support would be the responsibility of my family. If I am not able to provide this support, the school has the
			  rights to reconsider my child's enrolment based on the profile of the school community, the availability of the
			  school's support and resources that it could provide, keeping in mind the best educational needs of my child and
			  other children. This reconsideration may be needed even if the shadow teacher is provided.</p>
		  <p>I agree that in the case the school requires further clarification after submitting the application documents,
			  the school reserves the right to contact my child's previous school or learning centre.</p>
		  <p>I understand that the payment of an application fee and student insurance fee is payable for International
			  School applications and the school shall be entitled to increase the school fees from time to time. I am aware
			  that any fee increase will be notified to me in writing and the increased fee shall be payable by me effective
			  from the date stipulated in the notice.</p>
		  <p>I understand that application fee is strictly non-pro rata / non-refundable.</p>
		  <p>I accept that if tuition fees are not paid on the invoice due date, that my child’s enrolment will be
			  discontinued.</p>
		  <p>I declare that there are no outstanding debt from my child’s previous school.</p>
		  <p>
			  I understand that all information provided in this form is necessary for the school to facilitate the child's
			  course  -enrollment process, verification by the school when required and that all information provided shall be
			  classified confidential and used as per the school's Data Management Policy and EtonHouse International School
			  Personal Data Protection Policy (a copy can be viewed at
			  <a href="https://www.etonhouse.edu.sg/etonhouse-personal-data-protection-policy-statement/" target="_blank">https://www.etonhouse.edu.sg/etonhouse-personal-data-protection-policy-statement/</a>).
		  </p>
		  <hr style="margin-top: 2rem; margin-bottom: 2rem"/>
		  <div style="margin-bottom: 15px; font-size: 16px">
			  <label style="margin-bottom: 0">Acknowledgement of Late Course Commencement</label>
			  <label style="margin-bottom: 0">(Applicable ONLY to students who are not commencing their studies at the start
				  of the school's Academic Year).</label>
		  </div>
		  <p>By signing this Student Application Form, I acknowledged that the school's Admission Staff has informed me that
			  the course has already commenced in August and that my child will join the course partway through. I, therefore,
			  agreed to enrol my child despite being fully aware that the course has already commenced. Also, the school will
			  not be held responsible should my child be unable to fulfil all the course requirements by the completion
			  date.</p>
		  <p>
			  {{appCustomContent.declarationContent[selectOptSchool?.includes("SCH201300000254")?selectOptSchool:"default"]}}
		  </p>
		  <hr style="margin-top: 2rem; margin-bottom: 2rem"/>
		  <label>I have read, understood and agree to the terms and conditions of EtonHouse International School Pte
			  Ltd.</label>
	  </div>
	  <div v-if="group === 'PRE'">
		  <p>I declare that the information on this application form is true and accurate to my full knowledge. I agree that in the case of special educational needs, the school must assess carefully whether it can provide adequate support for my child before accepting my child’s application. I understand that any failure to declare such information will result in the offer of a place being withdrawn or my child being asked to leave the school.</p>
		  <p>I understand that the payment of non-refundable registration fee, student insurance, and refundable deposit is compulsory for registration.</p>
		  <p>I understand that the school shall be entitled to increase the school fees from time to time. I am aware that any fee increase will be notified to me in writing and the increased fee shall be payable by me effective from the date stipulated in the notice.</p>
		  <p>I have read, understood, and agreed to the Enrolment Terms and Conditions. </p>
		  <hr style="margin-top: 2rem; margin-bottom: 2rem"/>
		  <p>I give consent to EtonHouse to include my child in publications, promotional photos/videos, IB materials, and social media postings not limited to Facebook, Instagram, or Youtube within Singapore and internationally. </p>

		  <el-radio v-model="agreePublications" label="Yes">Yes</el-radio>
		  <el-radio v-model="agreePublications" label="No">No</el-radio>

		  <p>I acknowledge that this application and payment process does not guarantee my child's admission to the school. EtonHouse reserves the right to review the application and reject it when necessary.</p>
		  <el-checkbox :disabled="!isRead" v-model="checked" @change="onTermsChecked">I have read and agree to the <a @click="viewDoc" style="color: var(--link)"  target="_blank">Enrolment Terms and Conditions</a><br/>Kindly download, sign and upload T&Cs in next step.</el-checkbox>
		  <hr/>
	  </div>
    <div v-if="group === 'MIS'">
      <p>I declare that the information on the Student Registration Form and all supporting documents are true and accurate to
        my full knowledge. I understand that all applications are subject to review and the placement is subject to
        vacancies available and the approval of the Academic Board. A Pre-Enrolment Assessment Test and/or interview may
        be required to determine if a place can be offered. In the event of a waitlist application, I understand that
        placement is subject to a place becoming available and that this may be after my proposed commencement date.</p>

      <p>I agree that in the case of learning support needs, the school will carefully assess whether it can provide
        adequate support for my child to be successful in his/her learning before confirming my child’s enrolment. I
        understand that any failure to declare such information will result in the outcome of the application and the
        school reserves the right to withdraw and/or reject any application if found any breaches or dishonesty in the
        application or impact the continued enrolment of my child. Disclosing all required information will ensure that
        informed decisions are made in the best interest of my child. I agree that in the event the school identifies a
        learning need prior to or during my child’s term of enrolment, the school reserves the right to withdraw my
        application or reconsider my child’s enrolment based on the school resources and level of support required for
        my child.</p>

      <p>I agree that in the case the school requires further clarification after submitting the application documents,
        the school reserves the right to contact my child’s previous school or learning centre.</p>

      <p>I understand that the administration fee, confirmation fee and student insurance fee is payable for
        International School applications and the school shall be entitled to increase the course fees. I am aware that
        any fee increase will be notified to me in writing and the increased fee shall be payable by me effective from
        the date stipulated in the student contract.</p>

      <p>I understand that the Administration Fee and Confirmation Fee is strictly non-pro rata and non-refundable.</p>

        <p>I understand that the Pre-Enrolment Assessment Test and Student Pass Application & Renewal Fee is non-pro rata and non-refundable.  (If applicable).</p>

      <p>I accept that if the course fees are not paid on the invoice due date, that my child’s enrolment will be
        discontinued.</p>

      <p>I declare that there is no outstanding debt from my child’s previous school.</p>

      <p>I understand that if I wish to withdraw my child I must complete the withdrawal from and submit to the school
        before the deadline indicated in the Student Contract and Parent Handbook.</p>

      <p>
        I understand that all information provided in the form shall be classified confidential and used as per the school’s
        <a href="https://www.middleton.edu.sg/wp-content/uploads/2023/09/Middleton-Personal-Data-Protect-Statement-23-Aug-2023.pdf" target="_blank">
          <strong>Personal Data Protection Statement</strong>
        </a>
      </p>

      <p>(Please note that all students studying at Middleton International School are required by the Committee of
        Private Education (CPE) to sign a Standard Student Contract.)</p>

      <template v-if="withAcknowledgement">
          <hr style="margin-top: 2rem; margin-bottom: 2rem"/>
          <div style="margin-bottom: 15px; font-size: 16px">
              <label style="margin-bottom: 0">Acknowledgement of Late Course Commencement</label>
          </div>
          <p>By signing this Student Registration Form, I acknowledge that the school’s Parent Liaison Team has informed me
              that the course has already commenced and that my child will join the course part way through. I am fully aware
              and agree for my child to join part way through the course which has commenced. The school will not be held
              responsible should my child be unable to fulfill all course requirements by the completion date.
          </p>
          <hr style="margin-top: 2rem; margin-bottom: 2rem"/>
          <label>I have read, understood and agreed to the Terms & Conditions and the Late Course Commencement of Middleton
              International School Pte Ltd.</label>
      </template>
    </div>
  </main>
</template>

<script>
import { appCustomContent } from "@/pages/application/const/applicationConst";

export default {
  props: ["group","withAcknowledgement","preschoolInfo","isConsent","selectOptSchool","customDoc"],
	data(){
		return{
			checked:false,
			agreePublications: this.isConsent || "" ,
			isRead: false,
			appCustomContent
		}
	},
	watch:{
		agreePublications(value){
			this.$emit('change', value)
		},
	},
	methods:{
		onTermsChecked(){
			this.$emit('onCheck', this.checked )
		},
		viewDoc(){
			window.open(this.customDoc??this.preschoolInfo?.termInfo, '_blank');
			this.isRead = true
		}
	}
};
</script>